import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ children }) => {
    const token = localStorage.getItem('token');
    const expiresAt = localStorage.getItem('expires_at');

    if (!token) {
        return <Navigate to="/Login" replace />;
    }

    if (expiresAt && new Date(expiresAt) <= new Date()) {
        localStorage.removeItem('token');
        localStorage.removeItem('expires_at');
        localStorage.removeItem('login');
        localStorage.removeItem('infoUser');
        return <Navigate to="/Login" replace />;
    }

    return children;
};

export default ProtectedRoute;
